import axios from "axios";
import { API_URL } from "../config/baseurl";
const API = `${API_URL}/user`;

interface LoginResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
}

interface MessageResponse {
  msg: string;
}

export const login = async (
  email: string,
  password: string
): Promise<LoginResponse> => {
  const result = await axios.post<LoginResponse>(`${API}/login`, {
    email,
    password,
  });
  return result.data;
};

export const forgotPassword = async (
  email: string
): Promise<MessageResponse> => {
  const result = await axios.post<MessageResponse>(
    `${API}/password/forgot`,
    email
  );
  return result.data;
};

export const resetPassword = async (
  token: string,
  new_password: string
): Promise<MessageResponse> => {
  const result = await axios.post<MessageResponse>(`${API}/password/reset`, {
    token,
    new_password,
  });
  return result.data;
};
